import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class LeadAutomationResult  {
    _originalTypeClassName = "zPMO.BO.LeadAutomationResult";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
LeadAutomationResult.translate = translateService;
}
this.LeadAutomationResultKey = null;
this._key = this.LeadAutomationResultKey = 0; 
}

static translate: TranslateService;
_key: any;
Lead:any;
Project:any;
private _LeadAutomationResultKey:any;
get LeadAutomationResultKey(): any {
    return this._LeadAutomationResultKey;
  }
set LeadAutomationResultKey(value: any) {
    this._LeadAutomationResultKey = value;
    this._key = value;
  }
static setLead = ($this, value) => {
var oldValue = $this.Lead;
$this.Lead = value;
if (value != null) {
}
}
static setProject = ($this, value) => {
var oldValue = $this.Project;
$this.Project = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.LeadAutomationResultKey == null || $this.LeadAutomationResultKey == 0;
            }


}